import { Box, Button } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import MediaLibraryFileBlock from '../../../../shared/components/frontoffice/MediaLibraryFileBlock'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'

function LibraryContentCards({ filters, handleDownload, handleFavorite, handleClickMediaFileBlock, nextPage }: any) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { resources = [], hasMore, loading } = useSelector((state: IRootState) => state.resource)

  return (
    <Box>
      <Grid container spacing={isMobile ? 1 : 3}>
        {resources.map((resource: any) => (
          <MediaLibraryFileBlock
            data={resource}
            brand={filters.brand_id !== null ? '' : resource.brand_name}
            vipContent={resource.visibility === 1}
            hasaccess={
              resource.visibility === 1 &&
              (authUser.vip_lines.includes(resource.line_id) ||
                (resource.line_id === null && authUser.vip_brands.includes(resource.brand_id)) ||
                [1, 2, 3, 5].includes(authUser.role_id))
            }
            handleClick={handleClickMediaFileBlock}
            handleDownload={handleDownload}
            handleFavorite={handleFavorite(resource.id)}
          />
        ))}
      </Grid>
      {!loading && hasMore
        ? ((
            <Box mt={6} pb={4} style={{ textAlign: 'center' }}>
              <Button id="btn-see-more" variant="contained" size="large" color="primary" onClick={() => nextPage()}>
                {t('see-more')}
              </Button>
            </Box>
          ) as React.ReactNode)
        : null}
    </Box>
  )
}
export default LibraryContentCards
